import { cloneDeep } from 'lodash';

import { ConferenceParticipant } from '../../../../../objects/communication/conference-participant/conference-participant';
import { SerializableObjectSchema } from '../../../../../objects/generic/serialization/serializable-object-schema';
import { CommunicationsRequestName } from '../../../communications-request-name';
import { CommunicationsResponse } from '../../generic/communications-response/communications-response';
import { CommunicationsResponseSchema } from '../../generic/communications-response/communications-response-schema';

import { CommunicationsResponseGetConferenceParticipantsConstructor } from './communications-response-get-conference-participants-constructor';
import { CommunicationsResponseGetConferenceParticipantsError } from './communications-response-get-conference-participants-error';
import { CommunicationsResponseGetConferenceParticipantsSchema } from './communications-response-get-conference-participants-schema';

export class CommunicationsResponseGetConferenceParticipants extends CommunicationsResponse<CommunicationsResponseGetConferenceParticipantsError> {
  /////////////////////////////////////////////////////////////////////////////
  // Variables
  /////////////////////////////////////////////////////////////////////////////

  protected participants!: ConferenceParticipant[] | undefined;

  /////////////////////////////////////////////////////////////////////////////
  // Constructor
  /////////////////////////////////////////////////////////////////////////////

  constructor(parameters: CommunicationsResponseGetConferenceParticipantsConstructor) {
    super({
      ...parameters,
      [CommunicationsResponseSchema.type]: CommunicationsRequestName.getConferenceParticipants,
    });
  }

  /////////////////////////////////////////////////////////////////////////////
  // Deserialize
  /////////////////////////////////////////////////////////////////////////////

  /**
   * This static function is private, and meant to be called only by
   * SerializableObject, and subclasses
   *
   * @param validationResult
   */
  protected static _deserialize(
    validationResult: import('joi').ValidationResult,
  ): CommunicationsResponseGetConferenceParticipants {
    return new CommunicationsResponseGetConferenceParticipants(super._deserialize(validationResult));
  }

  /////////////////////////////////////////////////////////////////////////////
  // Serialize
  /////////////////////////////////////////////////////////////////////////////

  public serialize() {
    return super.serialize(CommunicationsResponseGetConferenceParticipants.getSchema());
  }

  /////////////////////////////////////////////////////////////////////////////
  // Schema
  /////////////////////////////////////////////////////////////////////////////

  public static getSchema(): SerializableObjectSchema {
    return new CommunicationsResponseGetConferenceParticipantsSchema();
  }

  /////////////////////////////////////////////////////////////////////////////
  // Getters
  /////////////////////////////////////////////////////////////////////////////

  public getParticipants(): ConferenceParticipant[] {
    return cloneDeep(this.participants ?? []);
  }

  public getParticipantCount(): number {
    return this.participants?.length ?? 0;
  }
}
